module.exports = __webpack_public_path__ + "static/img/presysv70.6f47e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv70.png
// module id = OyMq
// module chunks = 1